import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function PendingApprovalPage() {
  const { user, logout } = useAuth();

  return (
    <div className="pending-page">
      <div className="pending-card">
        <h1>🥾 Access Pending</h1>
        <p>Hi {user?.display_name || 'there'},</p>
        <p>
          Your access request has been submitted. A community administrator will
          review and approve your account shortly.
        </p>
        <p>You'll be able to access the trails map once approved.</p>
        <button onClick={logout} className="btn-secondary">Sign Out</button>
      </div>
    </div>
  );
}
